
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "ChatBotIcon",

  setup(_, { emit }) {
    const openChatBot = () => {
      emit("open");
    };

    return {
      openChatBot,
    };
  },
});
